import styled from 'styled-components';
import { palette } from 'styled-tools';

import { FontSizes, minWidth, Text } from '@calm-web/design-system';

export const Wrapper = styled.section`
	margin: 0 auto;
	max-width: 1440px;
	padding: 0 24px;
	text-align: center;
	width: 100%;

	${minWidth('desktop')} {
		padding: 0 136px 100px;
	}
`;
export const Heading = styled(Text).attrs({
	el: 'h2',
	color: 'bannerText',
	noMargin: true,
})`
	&&& {
		font-size: 24px;
		margin-bottom: 8px;

		${minWidth('desktop')} {
			font-size: 36px;
		}
	}
`;
export const CopyWrapper = styled.div`
	padding: 0 20px;

	${minWidth('desktop')} {
		padding: 0;
	}
`;
export const Copy = styled(Text).attrs({
	el: 'p',
	color: 'blackAlpha80',
	size: FontSizes.base,
})`
	&&& {
		margin: 0 auto;
		max-width: 700px;

		${minWidth('desktop')} {
			margin: 0 auto;
		}
	}
`;
export const ContentWrapper = styled.div`
	background: ${palette('white')};
	border-radius: 20px;
	margin-top: 32px;
	padding: 32px 20px 0;
	position: relative;

	${minWidth('desktop')} {
		margin-top: 64px;
	}

	@media screen and (min-width: 1200px) {
		padding: 84px 120px 0;
	}
`;
export const ButtonsWrapper = styled.div`
	justify-content: center;
	display: flex;
	gap: 10px;
	flex-wrap: wrap;
	list-style: none;
	padding: 0;

	@media screen and (min-width: 1200px) {
		column-gap: 24px;
		left: 50%;
		position: absolute;
		top: 0;
		transform: translate3d(-50%, -50%, 0);
		width: 100%;
	}
`;
